import React from 'react';
import { ShieldCheck, ShieldAlert, AlertTriangle } from 'lucide-react';
import { Card, CardContent } from '../../../../components/ui/card';

interface MAMRiskMeterProps {
  score: number; // 0 to 100
  level?: 'low' | 'medium' | 'high' | 'critical';
}

export default function MAMRiskMeter({ score, level }: MAMRiskMeterProps) {
  let colorClass =
    'text-emerald-600 bg-emerald-100 border-emerald-300 dark:bg-emerald-950/60 dark:text-emerald-300';
  let label = 'Low Risk Exposure';
  let Icon = ShieldCheck;

  const activeLevel =
    level || (score > 70 ? 'critical' : score > 40 ? 'medium' : 'low');

  if (activeLevel === 'critical' || activeLevel === 'high' || score > 70) {
    colorClass =
      'text-rose-600 bg-rose-100 border-rose-300 dark:bg-rose-950/60 dark:text-rose-300';
    label =
      activeLevel === 'critical'
        ? 'Critical Risk Warning'
        : 'High Risk Warning';
    Icon = ShieldAlert;
  } else if (activeLevel === 'medium' || score > 40) {
    colorClass =
      'text-amber-600 bg-amber-100 border-amber-300 dark:bg-amber-950/60 dark:text-amber-300';
    label = 'Moderate Risk Exposure';
    Icon = AlertTriangle;
  }

  return (
    <Card className="border shadow-sm">
      <CardContent className="p-4 flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className={`p-2.5 rounded-full border ${colorClass}`}>
            <Icon className="w-5 h-5" />
          </div>
          <div>
            <p className="text-xs text-muted-foreground font-medium">
              Global Risk Index
            </p>
            <p className="text-sm font-bold text-foreground">{label}</p>
          </div>
        </div>
        <div className="text-right">
          <span className="text-2xl font-extrabold text-foreground">
            {score}
          </span>
          <span className="text-xs text-muted-foreground">/100</span>
        </div>
      </CardContent>
    </Card>
  );
}
